export default "__VITE_ASSET__CXRK$sLM__"